// @ts-nocheck

import { ModalUI } from 'sonata-react-components';
import styled from 'styled-components';

export const ReportingConnectSonataLIModalStyle = styled(ModalUI)`
  .connectSonataLIModal {
    &__container {
      display: flex;
      flex-direction: column;
      width: 100%;
    }
    &__nameContainer {
      display: flex;
      gap: 16px;
    }

    &__metricsSelectorContainer {
      &__sectionHeader {
        font-size: 16px;
        line-height: 19px;
        margin: 32px 0;
      }
      &__Box {
        .multipleTagSelector {
          display: flex;
          flex-wrap: wrap;
          column-gap: 0;
          & > * {
            margin: 8px;
          }
        }
      }
    }
  }
`;
